var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail.file_preview)?_c('div',{attrs:{"id":"preview"}},[_c('embed',{ref:"preview",attrs:{"src":_vm.detail.file_preview,"type":"application/pdf"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }